(ns manatee.routing.url
  (:require [kee-frame.core :as kf]
            [lambdaisland.uri :as uri]))

(defn query-params
  []
  (uri/query-string->map #?(:cljs (subs js/window.location.search 1)
                            :clj "")))

(defn path-for
  [route query-params]
  (cond-> (kf/path-for route)
    (seq query-params) (str "?" (uri/map->query-string query-params))))

(defn absolute-url
  [base-url relative-path]
  #?(:cljs (-> (js/URL. relative-path base-url)
               (.toString))
     :clj  (-> (java.net.URI. base-url)
               (.resolve relative-path)
               (str))))

(defn absolute-path-for
  [base-url route]
  (absolute-url base-url (kf/path-for route)))
